import { Grid } from '@chakra-ui/react'
import { CircleDot, Package, Store, CheckCircle2, Ban, CircleSlash } from 'lucide-react'
import type { HelpdeskDashboardStats } from '@/lib/services/helpdeskDashboardService'
import DashboardStatCard from './DashboardStatCard'

type StatusItem = {
  key: keyof HelpdeskDashboardStats
  label: string
  icon: typeof CircleDot
  accent: string
  avgHoldKey?: keyof HelpdeskDashboardStats
  maxHoldKey?: keyof HelpdeskDashboardStats
}

const ITEMS: StatusItem[] = [
  { key: 'kpi_open', label: 'Open', icon: CircleDot, accent: 'blue.400' },
  {
    key: 'kpi_on_hold_parts',
    label: 'On Hold (Parts)',
    icon: Package,
    accent: 'yellow.400',
    avgHoldKey: 'kpi_on_hold_parts_avg_hold',
    maxHoldKey: 'kpi_on_hold_parts_max_hold',
  },
  {
    key: 'kpi_on_hold_customer',
    label: 'On Hold (Client / Store)',
    icon: Store,
    accent: 'orange.400',
    avgHoldKey: 'kpi_on_hold_customer_avg_hold',
    maxHoldKey: 'kpi_on_hold_customer_max_hold',
  },
  { key: 'kpi_resolved_incomplete', label: 'Resolved Incomplete', icon: CircleSlash, accent: 'purple.300' },
  { key: 'kpi_closed', label: 'Closed', icon: CheckCircle2, accent: 'green.400' },
  { key: 'kpi_cancelled', label: 'Cancelled', icon: Ban, accent: 'gray.400' },
]

type Props = {
  stats: HelpdeskDashboardStats
  loading?: boolean
}

export default function TicketStatusStrip({ stats, loading }: Props) {
  return (
    <Grid
      templateColumns={{ base: '1fr 1fr', sm: 'repeat(3, 1fr)', xl: 'repeat(6, 1fr)' }}
      gap={2.5}
      w="100%"
      minW={0}
    >
      {ITEMS.map(({ key, label, icon: Icon, accent, avgHoldKey, maxHoldKey }) => {
        const avgHold = avgHoldKey ? (stats[avgHoldKey] as string | null | undefined) : null
        const maxHold = maxHoldKey ? (stats[maxHoldKey] as string | null | undefined) : null
        const count = (stats[key] as number) ?? 0
        const subtitle =
          avgHoldKey != null
            ? count > 0 && avgHold
              ? `Avg hold ${avgHold}`
              : 'Avg hold —'
            : null
        const tooltip =
          avgHoldKey != null && count > 0 && (avgHold || maxHold)
            ? `Avg hold ${avgHold ?? '—'} · Max ${maxHold ?? '—'}`
            : undefined

        return (
          <DashboardStatCard
            key={key}
            label={label}
            value={count}
            loading={loading}
            accent={accent}
            subtitle={subtitle}
            subtitleColor="orange.600"
            tooltip={tooltip}
            icon={<Icon size={15} strokeWidth={2} />}
            to="/tickets"
          />
        )
      })}
    </Grid>
  )
}
